// import React from 'react';
// import { 
//   Globe2, ShieldAlert, Landmark, Briefcase, 
//   ChevronLeft, CheckCircle2, ShieldCheck, FileText, 
//   HelpCircle, PlaneTakeoff 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function ForeignInvestmentServices() {
  
//   // Core foreign investment and market entry offerings
//   const investmentServices = [
//     {
//       title: "إصدار تراخيص وزارة الاستثمار (MISA)",
//       desc: "استخراج وتجديد التراخيص الاستثمارية بأنواعها المختلفة (خدمي، صناعي، تجاري، عقاري، مقاولات) وتعديلها وفقاً للاحتياجات التوسعية للشركات الأجنبية.",
//       icon: <Globe2 className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "تأسيس وقيد الشركات الأجنبية والمختلطة",
//       desc: "تأسيس الشركات ذات المسؤولية المحدودة والمساهمة المقفلة وفروع الشركات الأجنبية، وصياغة عقود التأسيس وقيدها في السجل التجاري وإصدار شهادات الامتثال.",
//       icon: <Landmark className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "اتفاقيات الشركاء وحوكمة الكيانات",
//       desc: "صياغة اتفاقيات المساهمين (Shareholders' Agreements) العابرة للحدود، وتنظيم آليات خروج ودخول الشركاء، وحل النزاعات، وضمان توافقها التام مع نظام الشركات السعودي الجديد.",
//       icon: <FileText className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "الامتثال الضريبي والنظامي المحلي",
//       desc: "تقديم الدعم والمشورة القانونية بخصوص الأنظمة العمالية المحلية، تسجيل المنشأة في التأمينات الاجتماعية، والتوافق مع متطلبات هيئة الزكاة والضريبة والجمارك (ZATCA).",
//       icon: <ShieldCheck className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات الاستثمار الأجنبي وتأسيس الشركات"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">بوابتك القانونية الموثوقة للاستثمار في أكبر أسواق المنطقة</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات الاستثمار الأجنبي وتأسيس الشركات</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نوفر للمستثمرين والشركات العالمية منظومة استشارية وإجرائية متكاملة لتأسيس وإطلاق أعمالهم بنجاح داخل المملكة العربية السعودية، مع ضمان الامتثال الكامل لجميع المتطلبات التنظيمية المحلّية.
//           </p>
//         </div>
//       </section>

//       {/* Analytical & Strategic Market Value */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12 items-center">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6 leading-tight">
//               توجيه قانوني احترافي يحمي تدفقاتك الاستثمارية من الخطوة الأولى
//             </h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               إن اتخاذ القرار بالدخول إلى السوق السعودي يتطلب دراسة واعية للهيكل القانوني الأنسب لنشاطك التجاري. إن الاختيار الخاطئ لنوع الشركة أو بنود اتفاقية الشركاء قد يترتب عليه قيود تشغيلية أو تعقيدات ضريبية غير متوقعة تؤثر على ربحية المنشأة.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               يتولى فريقنا القانوني تسيير كافة الإجراءات التنفيذية بالنيابة عنك؛ بدءاً من صياغة خطط العمل وتوفير المستندات المطلوبة لوزارة الاستثمار، مروراً بفتح الحسابات البنكية الاستثمارية، وحتى الصياغة الدقيقة للاتفاقيات التي تحمي حقوق الملكية وتضمن مرونة حركة رأس المال وتوزيع الأرباح بسلاسة.
//             </p>
//           </div>
          
//           {/* Why Invest In Saudi Arabia Checklist Box */}
//           <div className="w-full lg:w-80 bg-slate-900 text-white p-6 rounded-xl border border-slate-800 space-y-4 shadow-lg">
//             <h3 className="font-bold text-amber-500 text-base flex items-center gap-2">
//               <PlaneTakeoff className="w-5 h-5" /> حوافز التأسيس للمستثمر الأجنبي:
//             </h3>
//             <ul className="space-y-3 text-xs text-slate-300">
//               <li className="flex items-center gap-2">
//                 <CheckCircle2 className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>إمكانية التملك الكامل للمنشآت بنسبة 100% دون شريك محلي.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle2 className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>الاستفادة من برامج الدعم والتمويل الحكومية للمشاريع الواعدة.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle2 className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>تسهيلات إصدار التأشيرات والاقامات المميزة لرواد الأعمال.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle2 className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>مظلة قانونية تحمي الأصول والملكية الفكرية بموجب الاتفاقيات الدولية.</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Grid: Service Breakdown */}
//       <section className="max-w-6xl mx-auto py-12 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">منظومة حلول التأسيس والامتثال الدولي</h2>
//           <p className="text-gray-500">نرافق استثماراتك من مرحلة دراسة الخيارات النظامية حتى بدء عمليات التشغيل التجاري الفعلي</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {investmentServices.map((service, index) => (
//             <div key={index} className="bg-white p-8 rounded-xl border border-gray-100 hover:border-amber-500 hover:shadow-md transition-all duration-300">
//               <div className="p-3 bg-slate-50 rounded-lg w-fit text-slate-700 mb-4">
//                 {service.icon}
//               </div>
//               <h3 className="text-xl font-bold text-slate-800 mb-2">{service.title}</h3>
//               <p className="text-gray-500 text-sm leading-relaxed">{service.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Regulatory Context Warning (HQ / Regional HQ Rules) */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <ShieldAlert className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">تنبيه استراتيجي بشأن المقرات الإقليمية (Regional HQ):</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               تماشياً مع الضوابط الحالية المقررة في المملكة العربية السعودية، فإن الشركات العالمية التي تسعى للتعاقد مع الجهات الحكومية أو المؤسسات التابعة للدولة يتوجب عليها تأسيس **مقر إقليمي لها في المملكة**. نوفر لعملائنا الدوليين الاستشارات المتكاملة لهيكلة المقرات الإقليمية لضمان الاستفادة من الإعفاءات الضريبية والحوافز التشغيلية الممنوحة لهذه الفئة من الشركات.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Action Banner for Lead Generation */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <Briefcase className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل تخطط لتوسيع نطاق أعمالك وتأسيس شركتك في المملكة؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           تواصل مع مستشارينا الدوليين اليوم للحصول على دراسة مبدئية لمتطلبات ترخيص نشاطك التجاري، وبدء خطوات قيد منشأتك بشكل نظامي وآمن.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           ابدأ إجراءات الاستثمار وتأسيس الشركات الآن
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }

import React from 'react';
import { 
  Globe2, ShieldAlert, Landmark, Briefcase, 
  ChevronLeft, CheckCircle2, ShieldCheck, FileText, 
  HelpCircle, PlaneTakeoff 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';

export default function ForeignInvestmentServices() {
  
  // Core foreign investment and market entry offerings - Refactored to Navy Light
  const investmentServices = [
    {
      title: "إصدار تراخيص وزارة الاستثمار (MISA)",
      desc: "استخراج وتجديد التراخيص الاستثمارية بأنواعها المختلفة (خدمي، صناعي، تجاري، عقاري، مقاولات) وتعديلها وفقاً للاحتياجات التوسعية للشركات الأجنبية.",
      icon: <Globe2 className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "تأسيس وقيد الشركات الأجنبية والمختلطة",
      desc: "تأسيس الشركات ذات المسؤولية المحدودة والمساهمة المقفلة وفروع الشركات الأجنبية، وصياغة عقود التأسيس وقيدها في السجل التجاري وإصدار شهادات الامتثال.",
      icon: <Landmark className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "اتفاقيات الشركاء وحوكمة الكيانات",
      desc: "صياغة اتفاقيات المساهمين (Shareholders' Agreements) العابرة للحدود، وتنظيم آليات خروج ودخول الشركاء، وحل النزاعات، وضمان توافقها التام مع نظام الشركات السعودي الجديد.",
      icon: <FileText className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "الامتثال الضريبي والنظامي المحلي",
      desc: "تقديم الدعم والمشورة القانونية بخصوص الأنظمة العمالية المحلية، تسجيل المنشأة في التأمينات الاجتماعية، والتوافق مع متطلبات هيئة الزكاة والضريبة والجمارك (ZATCA).",
      icon: <ShieldCheck className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات الاستثمار الأجنبي وتأسيس الشركات"
        description="نقدم السيادة الاستشارية والحلول القانونية المتكاملة لتأمين دخول استثماراتكم الدولية للسوق السعودي"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">بوابتك القانونية الموثوقة للاستثمار في أكبر أسواق المنطقة</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات الاستثمار الأجنبي وتأسيس الشركات</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نوفر للمستثمرين والشركات العالمية منظومة استشارية وإجرائية متكاملة لتأسيس وإطلاق أعمالهم بنجاح داخل المملكة العربية السعودية، مع ضمان الامتثال الكامل لجميع المتطلبات التنظيمية المحلّية.
          </p>
        </div>
      </section>

      {/* Analytical & Strategic Market Value */}
    {/* Why Invest In Saudi Arabia - Optimized Responsive Desktop Layout */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 flex flex-col lg:flex-row gap-8 lg:gap-12 items-center lg:items-stretch">
          
          {/* Main Text Content */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              توجيه قانوني احترافي يحمي تدفقاتك الاستثمارية من الخطوة الأولى
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              إن اتخاذ القرار بالدخول إلى السوق السعودي يتطلب دراسة واعية للهيكل القانوني الأنسب لنشاطك التجاري. إن الاختيار الخاطئ لنوع الشركة أو بنود اتفاقية الشركاء قد يترتب عليه قيود تشغيلية أو تعقيدات ضريبية غير متوقعة تؤثر على ربحية المنشأة.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              يتولى فريقنا القانوني تسيير كافة الإجراءات التنفيذية بالنيابة عنك؛ بدءاً من صياغة خطط العمل وتوفير المستندات المطلوبة لوزارة الاستثمار، مروراً بفتح الحسابات البنكية الاستثمارية، وحتى الصياغة الدقيقة للاتفاقيات التي تحمي حقوق الملكية وتضمن مرونة حركة رأس المال وتوزيع الأرباح بسلاسة.
            </p>
          </div>
          
          {/* Why Invest In Saudi Arabia Checklist Box - Fixed Desktop Responsiveness */}
          <div className="w-full lg:w-96 lg:max-w-md shrink-0 bg-indigo-950 text-white p-8 rounded-xl border border-indigo-900/50 space-y-5 shadow-md flex flex-col justify-center">
            <h3 className="font-bold text-white text-base flex items-center gap-2 border-b border-white/10 pb-3">
              <PlaneTakeoff className="w-5 h-5 text-blue-400" /> حوافز التأسيس للمستثمر الأجنبي:
            </h3>
            <ul className="space-y-4 text-xs md:text-sm text-slate-200 font-light">
              <li className="flex items-start gap-2.5">
                <CheckCircle2 className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>إمكانية التملك الكامل للمنشآت بنسبة 100% دون شريك محلي.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <CheckCircle2 className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>الاستفادة من برامج الدعم والتمويل الحكومية للمشاريع الواعدة.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <CheckCircle2 className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>تسهيلات إصدار التأشيرات والإقامات المميزة لرواد الأعمال.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <CheckCircle2 className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>مظلة قانونية تحمي الأصول والملكية الفكرية بموجب الاتفاقيات الدولية.</span>
              </li>
            </ul>
          </div>

        </div>
      </section>
      {/* Grid: Service Breakdown - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">منظومة حلول التأسيس والامتثال الدولي</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">نرافق استثماراتك من مرحلة دراسة الخيارات النظامية حتى بدء عمليات التشغيل التجاري الفعلي</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {investmentServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Regulatory Context Warning (HQ / Regional HQ Rules) - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <ShieldAlert className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">تنبيه استراتيجي بشأن المقرات الإقليمية (Regional HQ):</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              تماشياً مع الضوابط الحالية المقررة في المملكة العربية السعودية، فإن الشركات العالمية التي تسعى للتعاقد مع الجهات الحكومية أو المؤسسات التابعة للدولة يتوجب عليها تأسيس <strong className="text-indigo-950">مقر إقليمي لها في المملكة</strong>. نوفر لعملائنا الدوليين الاستشارات المتكاملة لهيكلة المقرات الإقليمية لضمان الاستفادة من الإعفاءات الضريبية والحوافز التشغيلية الممنوحة لهذه الفئة من الشركات.
            </p>
          </div>
        </div>
      </section>

      {/* Action Banner for Lead Generation - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <Briefcase className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل تخطط لتوسيع نطاق أعمالك وتأسيس شركتك في المملكة؟</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          تواصل مع مستشارينا الدوليين اليوم للحصول على دراسة مبدئية لمتطلبات ترخيص نشاطك التجاري، وبدء خطوات قيد منشأتك بشكل نظامي وآمن.
        </p>
        <button 
          onClick={() => openWhatsApp( "   ابدأ إجراءات الاستثمار وتأسيس الشركات الآن    ")}
        
        className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
          ابدأ إجراءات الاستثمار وتأسيس الشركات الآن
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}